import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'
import { fontWeight } from 'themes/font'
import breakPoints from 'themes/breakPoints'
import Item from './item'

const Section = styled.section`
  text-align: center;
  @media (max-width: ${breakPoints.md.max}px) {
    padding-top: 64px;
    padding-bottom: 48px;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    padding-top: 80px;
  }
`

const Heading = styled.h1`
  font-size: 35px;
  font-weight: ${fontWeight.bold};
  margin-top: 0;
  margin-bottom: 8px;
  @media (max-width: ${breakPoints.md.max}px) {
    font-size: 1.5rem;
  }
`

const Description = styled.p`
  font-size: 25px;
  @media (max-width: ${breakPoints.md.max}px) {
    margin-bottom: 16px;
    font-size: 1rem;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    margin-bottom: 16px;
  }
`

const Items = styled(Row)`
  justify-content: center;
`

const Background = styled.img`
  @media (max-width: ${breakPoints.md.max}px) {
    display: none;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    display: block;
    margin-left: auto;
    max-width: 100%;
  }
`

export default class OpenPositions extends PureComponent {
  render () {
    const { heading, description, items } = this.props.data
    return (
      <Section>
        <Container>
          <Heading className='wow fadeIn'>{heading}</Heading>
          <Description className='wow fadeIn'>{description}</Description>
          <Items className='wow fadeInUp'>
            {items.map((item, index) => (
              <Col xs={6} lg={4}>
                <Item key={index} {...item} />
              </Col>
            ))}
          </Items>
        </Container>
        <Background src='/img/bg/bg-2.svg' alt='Background' />
      </Section>
    )
  }
}
